import { Printer } from 'lucide-react';
import { useProtocol } from '../../api/queries.ts';
import { Banner, Button, PageHeader, Spinner } from '../../components/ui.tsx';
import { t } from '../../i18n/index.ts';
import { ProtocolDocument } from '../installer/ProtocolDocument.tsx';

/** the signed commissioning protocol, once the installer has released it to the customer */
export function ProtocolPage() {
  const protocol = useProtocol();
  return (
    <div className="space-y-4">
      <PageHeader title={t('protocol.title')}>
        {protocol.data && (
          <Button variant="secondary" className="print:hidden" onClick={() => window.print()}>
            <Printer size={18} /> {t('checklist.print')}
          </Button>
        )}
      </PageHeader>
      {protocol.isPending ? (
        <Spinner label={t('common.loading')} />
      ) : protocol.data ? (
        <ProtocolDocument checklist={protocol.data} />
      ) : (
        <Banner tone="muted" title={t('protocol.notReleased')} />
      )}
    </div>
  );
}
